/**
 * Состояние одной ленивой величины.
 * Варианты различаются составом полей, поэтому это размеченное объединение:
 * представление и обработка пишутся реестром по `status`, а не цепочкой if.
 *
 * Похоже на RemoteData из src/common, но не оно: там `error: Error`, а нам
 * нужен исходный объект ошибки — по `error.response.status` различаются 403,
 * 404 и всё остальное. Приведение к Error уничтожило бы эти данные.
 * Преобразование в RemoteData делает представление, если ему нужен LoaderBox.
 */
export type ResourceState<T> =
  | { status: "error"; error: unknown }
  | { status: "none" }
  | { status: "ready"; value: T }
  | { status: "wait" };

/**
 * Разбор состояния по варианту.
 *
 * Единственное место, где `status` разбирается: потребители пишут по ветке на
 * вариант и не могут забыть одну — добавление статуса обрушит компиляцию здесь.
 */
export type ResourceVisitor<T, R> = {
  none(): R;
  wait(): R;
  ready(value: T): R;
  error(error: unknown): R;
};

export const matchResource = <T, R>(
  state: ResourceState<T>,
  visitor: ResourceVisitor<T, R>,
): R => {
  switch (state.status) {
    case "none":
      return visitor.none();
    case "wait":
      return visitor.wait();
    case "ready":
      return visitor.ready(state.value);
    case "error":
      return visitor.error(state.error);
    default:
      throw Error(`Неизвестное состояние: ${JSON.stringify(state)}`);
  }
};
